import React from 'react'
import Allarticle from '../../components/journalcomponents/allarticle'

export default function Journal() {
  return (
    <>
      <Allarticle />
    </>
  )
}
